import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Welcome } from './components/Welcome';
import { Cabins } from './components/Cabins';
import { Services } from './components/Services';
import { Environment } from './components/Environment';
import { Attractions } from './components/Attractions';
import { Gallery } from './components/Gallery';
import { Location } from './components/Location';
import { Testimonials } from './components/Testimonials';
import { Social } from './components/Social';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-sand-light font-sans selection:bg-olive/30 selection:text-olive-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Welcome data-id="element-4" />
        <Cabins data-id="element-5" />
        <Services data-id="element-6" />
        <Environment data-id="element-7" />
        <Attractions data-id="element-8" />
        <Gallery data-id="element-9" />
        <Location data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Social data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <FloatingWhatsApp data-id="element-15" />
    </div>;
}